export const MessageIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3303 5.456C13.5053 5.345 13.5573 5.114 13.4453 4.939C13.3333 4.763 13.1013 4.714 12.9283 4.823L12.8443 4.876C10.0003 6.68 8.31435 7.594 7.83335 7.594C7.51635 7.594 6.38835 7.122 2.81435 4.872C2.63835 4.761 2.40735 4.814 2.29735 4.989C2.18635 5.165 2.23935 5.396 2.41435 5.507C5.61635 7.522 7.18535 8.344 7.83335 8.344C8.66235 8.344 10.9243 6.982 13.2453 5.51L13.3303 5.456Z"
      fill="currentColor"
    />
    <path
      d="M14.5498 2C15.3498 2 16 2.6502 16 3.4502V12.5498C16 13.3508 15.3498 14 14.5498 14H1.4502C0.649195 14 0 13.3508 0 12.5498V3.4502C0 2.6502 0.649195 2 1.4502 2H14.5498ZM1.4502 2.7959C1.0892 2.7959 0.794922 3.0902 0.794922 3.4502V12.5498C0.794922 12.9108 1.0892 13.2041 1.4502 13.2041H14.5498C14.9098 13.2041 15.2041 12.9108 15.2041 12.5498V3.4502C15.2041 3.0902 14.9098 2.7959 14.5498 2.7959H1.4502Z"
      fill="currentColor"
    />
  </svg>
);
